define('helper/appLayoutHelper',[],
    function (system, log, config, eventBroker) {

        function compositionComplete(html, parentHtml, context) {
            // note: you have to layout your jquery.ui.layouts from outer most to inner most in order.
            $("#app-container").layout({
                applyDemoStyles: true,
                north__size: 43,
                north__resizable: false,
                north__closable: false,
                scrollToBookmarkOnLoad: false // note: interferes with durandal routing.
            });
            return $.when(true);
        }

        return {
            compositionComplete: compositionComplete
        };

});
